import script from "./InfoForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoForm.vue?vue&type=script&lang=ts&setup=true"

import "./InfoForm.vue?vue&type=style&index=0&id=60393e62&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60393e62"]])

export default __exports__